import {
    createSelector,
    createEntityAdapter
} from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice"

const taskBasesAdapter = createEntityAdapter({
    sortComparer: (a, b) => (a.completed === b.completed) ? 0 : a.completed ? 1 : -1
})

const initialState = taskBasesAdapter.getInitialState()

export const taskBasesApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getTaskBases: builder.query({
            query: () => ({
                url: '/api/task-bases',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                },
            }), 
            providesTags: ['TaskBaseList'],        
           
        }),
        addNewTaskBase: builder.mutation({
            query: initialTaskBase => ({
                url: '/api/task-bases',
                method: 'POST',
                body: {
                    ...initialTaskBase,
                }
            }),
            invalidatesTags: ['TaskBaseList']
        }),
        addNewTaskBaseAction: builder.mutation({
            query: initialTaskBaseAction => ({
                url: '/api/task-bases/actions',
                method: 'POST',
                body: {
                    ...initialTaskBaseAction,
                }
            }),
            invalidatesTags: ['TaskBaseList']
        }),
        editTaskBaseAction: builder.mutation({
            query: initialTaskBaseAction => ({
                url: '/api/task-bases/actions',
                method: 'PATCH',
                body: {
                    ...initialTaskBaseAction,
                }
            }),
            invalidatesTags: ['TaskBaseList']
        }),
        deleteTaskBaseAction: builder.mutation({
            query: ({ id, taskBaseId }) => ({
                url: '/api/task-bases/actions',
                method: 'DELETE',
                body: { id, taskBaseId }
            }),
            invalidatesTags: ['TaskBaseList']
        }),


        updateTaskBase: builder.mutation({
            query: initialTaskBase => ({
                url: '/api/task-bases',
                method: 'PATCH',
                body: {
                    ...initialTaskBase,
                }
            }),
            invalidatesTags: ['TaskBaseList']
        }),
        deleteTaskBase: builder.mutation({
            query: ({ id }) => ({
                url: '/api/task-bases',
                method: 'DELETE',
                body: { id }
            }),
            invalidatesTags: ['TaskBaseList']
        }),
        importTasksFromGroup: builder.mutation({
            query: ({ group, course, taskId }) => ({
                url: '/api/task-bases/import',
                method: 'POST',
                body: { group, course ,taskId}
            }),
            invalidatesTags: ['TaskBaseList']
        }),
        exportTaskBasesToGroup: builder.mutation({
            query: (exportData) => ({
                url: '/api/task-bases/export',
                method: 'POST',
                body:{...exportData}
            }),
            invalidatesTags: [
                { type: 'Task', id: "LIST" },
                { type: 'Action', id: "LIST" }
            ]
        }),
        deleteMultiTaskBase: builder.mutation({
            query: ({selected}) => ({
                url: '/api/task-bases/delete-multi',
                method: 'DELETE',
                body: {selected}
            }),
            invalidatesTags: ['TaskBaseList']
        }),
    }),
})

export const {
    useGetTaskBasesQuery,
    useAddNewTaskBaseMutation,
    useUpdateTaskBaseMutation,
    useDeleteTaskBaseMutation,
    useAddNewTaskBaseActionMutation,
    useEditTaskBaseActionMutation,
    useDeleteTaskBaseActionMutation,
    useImportTasksFromGroupMutation,
    useExportTaskBasesToGroupMutation,
    useDeleteMultiTaskBaseMutation
} = taskBasesApiSlice

// returns the query result object
export const selectTaskBasesResult = taskBasesApiSlice.endpoints.getTaskBases.select()

// creates memoized selector
const selectTaskBasesData = createSelector(
    selectTaskBasesResult,
    taskBasesResult => taskBasesResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllTaskBases,
    selectById: selectTaskBaseById,
    selectIds: selectTaskBaseIds
    // Pass in a selector that returns the taskBases slice of state
} = taskBasesAdapter.getSelectors(state => selectTaskBasesData(state) ?? initialState)